import React from "react";
import { SkeletonCard } from "../../../components/ui";

/**
 * The three cards of the overview, at the heights they stand at: the dietitian
 * and their figures, their practice, and the tags they work under.
 *
 * Heights rather than contents — what is inside each card is the card's own
 * business once it lands. Two of them, because the same three cards are a good
 * deal taller on a phone: the header stacks the picture, the name and the
 * button, every pair of fields becomes a row of its own, and the last two carry
 * a caption above them. A block left at the desktop height there would be a
 * card and a half short, and the page would jump as the profile filled it in.
 */
const CARDS = [
  "h-[384px] md:h-[131px]",
  "h-[196px] md:h-[113px]",
  "h-[162px] md:h-[104px]",
];

/**
 * The overview while the profile is read.
 *
 * Three cards in the three places the real ones take, so the screen is already
 * drawn when the answer lands and nothing jumps as it fills in. One
 * `role="status"` line carries the whole thing for a screen reader — the blocks
 * themselves are hidden, since the shape of an answer read out is worse than
 * silence.
 */
const ProfileOverviewSkeleton: React.FC = () => (
  <div className="flex flex-col gap-4">
    <span role="status" className="sr-only">
      Loading your profile
    </span>

    {CARDS.map((height) => (
      <SkeletonCard key={height} className={height} />
    ))}
  </div>
);

export default ProfileOverviewSkeleton;
